import { render, staticRenderFns } from "./DashComponent2.vue?vue&type=template&id=a82ad760"
import script from "./DashComponent2.vue?vue&type=script&lang=js"
export * from "./DashComponent2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports